<template>
  <div class="text-xs-center">
    <v-toolbar dense flat card dark color="primary">
      <v-toolbar-title v-if="!isMobile">Attestati di : {{ nome }}</v-toolbar-title>
      <v-toolbar-title v-else>{{ nome }}</v-toolbar-title>
      <v-icon v-if="!isMobile" left class="hidden-sm-and-down ml-3">fa-graduation-cap</v-icon>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn @click="chiudiDialog()" flat>
          Chiudi
          <v-icon dark right>undo</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-layout row wrap class="mt-4 mb-3">
      <v-flex xs12 md2 mt-2 ml-2 class="px-1">
        <v-autocomplete
          v-model="filtroModalita"
          :items="['Formazione', 'Didattico']"
          :return-object="false"
          @change="changeModalita"
          box
          label="Tipo"
          clearable
          hide-details
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 md2 mt-2 class="px-1">
        <v-autocomplete v-model="filtroAnni" :items="anniList" :return-object="false" @change="changeAnni" box label="Anno di riferimento" clearable hide-details></v-autocomplete>
      </v-flex>
      <v-spacer></v-spacer>
      <v-icon left class="hidden-sm-and-down mr-3">search</v-icon>
      <v-flex xs12 md4 mt-2 mr-2 class="px-1">
        <v-text-field v-model="filtraAttestato" box label="Cerca" clearable hide-details></v-text-field>
      </v-flex>
    </v-layout>
    <v-data-table :search="filtraAttestato" :headers="headers" :hide-headers="isMobile" :items="attestatiFiltra" :pagination.sync="pagination" class="elevation-1">
      <template v-slot:items="props">
        <tr v-if="!isMobile">
          <td>
            <v-avatar v-if="props.item.CodiceTipoEvento === 'FOR'" size="24" color="purple" small>
              <span class="white--text xm">F</span>
            </v-avatar>
            <v-avatar v-else size="24" color="orange" small>
              <span class="white--text xm">D</span>
            </v-avatar>
          </td>
          <td class="text-xs-left">{{ props.item.CodiceTipoEvento === 'FOR' ? 'Formazione' : 'Didattico' }}</td>
          <td class="text-xs-left">{{ formattaData(props.item.DataAttestato) }}</td>
          <td class="text-xs-left">{{ props.item.AssociazioneDenominazione }}</td>
          <td class="text-xs-left">{{ props.item.LuogoEvento }}</td>
          <td class="text-xs-left font-weight-bold">{{ props.item.TitoloEvento }}</td>
          <td class="text-xs-left">{{ props.item.CodiceEvento }}</td>
          <td class="text-xs-left">
            <v-tooltip top>
              <v-btn slot="activator" @click="printAttestato(props.item)" small outline icon class="ma-1 mr-0" color="primary">
                <v-icon small color="primary">print</v-icon>
              </v-btn>
              <span>Scarica Tesserato</span>
            </v-tooltip>
          </td>
        </tr>
        <tr v-else :active="props.selected" style="padding-bottom: 35px;">
          <td class="flex-td">
            <ul class="flex-content">
              <li data-label="Data attestato" class="flex-item">{{ formattaData(props.item.DataAttestato) }}</li>
              <li data-label="Titolo" class="flex-item font-weight-bold">{{ props.item.TitoloEvento }}</li>

              <li data-label="Associazione" class="flex-item">{{ props.item.AssociazioneDenominazione }}</li>

              <li data-label="Luogo evento" class="flex-item">{{ props.item.LuogoEvento }}</li>
              <li data-label="Codice C.O.N.I." class="flex-item">{{ props.item.id }}</li>
              <li data-label="Pass " class="flex-item">
                <v-avatar v-if="props.item.CodiceTipoEvento === 'FOR'" size="24" color="purple" small>
                  <span class="white--text xm">F</span>
                </v-avatar>
                <v-avatar v-else size="24" color="orange" small>
                  <span class="white--text xm">D</span>
                </v-avatar>
                <v-tooltip top>
                  <v-btn slot="activator" @click="printAttestato(props.item)" small outline icon class="ma-1 mr-0" color="primary">
                    <v-icon small color="primary">print</v-icon>
                  </v-btn>
                  <span>Scarica Tesserato</span>
                </v-tooltip>
              </li>
            </ul>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogAttestato" persistent max-width="700">
      <v-card>
        <v-card-title class="display-1 font-weight-bold accent white--text">Scarica Attestato</v-card-title>
        <v-card-text class="headline">Scaricare l'attestato?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogAttestato = false" color="red white--text" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="downloadAttestato()" color="accent white--text" dark> <v-icon small class="mr-1">print</v-icon>Download Attestato </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import * as moment from 'moment';
  import 'moment/locale/it';
  import { bus } from '@/main';
  import CampiAnagraficaAssociato from '../generale/CampiAnagraficaAssociato';
  import Security from '@/security';
  import Util from '@/util';
  import AssociazioneEntity from '../associazioni/AssociazioneEntity';
  import AssociatoEntity from './AssociatoEntity';

  export default {
    props: ['idAssociato', 'nome'],
    data() {
      return {
        filtraAttestato: '',
        filtroLuogo: null,
        filtroModalita: null,
        filtroAnni: null,
        filtroAnniId: null,
        isMobile: false,
        dialogAttestato: false,
        headers: [
          { text: 'Modalità', value: 'isOpen', width: '80px', align: 'center', sortable: false },
          { text: 'Tipo', value: 'isOpen', width: '80px', align: 'center', sortable: false },
          { text: 'Data Attestato', value: 'DataAttestato', sortable: false },
          { text: 'Associazione', value: 'AssociazioneDenominazione', sortable: false },
          { text: 'Luogo', value: 'LuogoEvento', sortable: false },
          { text: 'Titolo evento', value: 'TitoloEvento', sortable: false },
          { text: 'Codice C.O.N.I.', value: 'CodiceEvento', sortable: false },
          { text: 'Action', value: '', sortable: false },
        ],
        pagination: {
          rowsPerPage: 10,
        },
      };
    },
    computed: {
      ...mapGetters('associatiModule', ['getAttestati']),
      ...mapGetters('sharedModule', ['getAnniSportivi']),

      attestati() {
        return this.getAttestati;
      },

      anniSportivi() {
        return this.getAnniSportivi;
      },

      anniList() {
        let anniSportiviEventi = [];
        this.anniSportivi.forEach((i) => {
          anniSportiviEventi.push(i.Descrizione);
        });
        return anniSportiviEventi;
      },

      luogoList() {
        let luoghiEventi = [];
        this.attestati.forEach((i) => {
          luoghiEventi.push(i.LuogoEvento);
        });
        return luoghiEventi;
      },

      attestatiFiltra(filtroAnni, filtroAnniId, filtroLuogo, filtroModalita) {
        let attestatiFiltrati = [];
        if (this.filtroAnni === null && this.filtroLuogo === null && this.filtroModalita === null) {
          attestatiFiltrati = this.attestati;
        }
        attestatiFiltrati = this.attestati;

        if (this.filtroAnni && this.filtroAnniId) {
          attestatiFiltrati = attestatiFiltrati.filter((i) => {
            return i.annoSportivoId === this.filtroAnniId;
          });
        }
        if (this.filtroLuogo) {
          attestatiFiltrati = attestatiFiltrati.filter((i) => {
            return i.LuogoEvento === this.filtroLuogo;
          });
        }
        if (this.filtroModalita) {
          attestatiFiltrati = attestatiFiltrati.filter((i) => {
            if (this.filtroModalita === 'Formazione') {
              return i.CodiceTipoEvento === 'FOR';
            } else {
              return i.CodiceTipoEvento === 'DIDA';
            }
          });
        }
        Util.sortArrayByKey(attestatiFiltrati, 'DataAttestato');
        return attestatiFiltrati;
      },
    },
    watch: {
      breakPoinSize() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
          case 'sm':
            this.isMobile = true;
            break;
          case 'md':
          case 'lg':
          case 'xl':
            this.isMobile = false;
            break;
        }
      },
      calculatedRow() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.pagination.rowsPerPage = 10;
            this.isMobile = true;
            break;
          case 'md':
            this.pagination.rowsPerPage = 15;
            this.isMobile = false;
            break;
          case 'lg':
            this.pagination.rowsPerPage = 20;
            this.isMobile = false;
            break;
          case 'xl':
            this.pagination.rowsPerPage = 25;
            this.isMobile = false;
            break;
        }
      },
    },
    created() {
      const vm = this;
      bus.$on('idSelezionato', function (value) {
        if (value) {
          vm.loadAttestati(value);
        }
        vm.filtroLuogo = null;
        vm.filtroModalita = null;
        vm.filtroAnni = null;
      });
      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
        case 'xs':
          this.isMobile = true;
          break;
        case 'md':
          this.isMobile = false;
          break;
        case 'lg':
          this.isMobile = false;
          break;
        case 'xl':
          this.isMobile = false;
          break;
      }
    },
    methods: {
      ...mapActions('eventiModule', ['stampaAttestatoAsync']),
      ...mapActions('associatiModule', ['stampaAttestato', 'stampaAttestatoFormativo', 'loadAttestati']),

      checkAttestato(item) {
        return item.StatoEvento === 'Chiuso' && (item.StatoIscrizione === 'Iscritto' || item.StatoIscrizione === 'Pagato');
      },
      printAttestato(item) {
        this.attestatoSelected = item;
        this.dialogAttestato = true;
      },
      downloadAttestato() {
        if (this.attestatoSelected) {
          this.stampaAttestatoAsync(this.attestatoSelected.id);
        }
        this.dialogAttestato = false;
      },

      formattaData(date) {
        if (!date) {
          return null;
        }
        return moment(date).format('DD/MM/YYYY');
      },

      chiudiDialog() {
        bus.$emit('chiusura', true);
      },

      changeAnni(i) {
        let idAnni = this.anniSportivi.filter(function (idAnno) {
          return idAnno.Descrizione == i;
        });
        this.filtroAnniId = idAnni[0].id;
        this.filtroAnni = i;
        this.attestatiFiltrati = this.attestatiFiltra(this.filtroAnni);
      },
      changeLuogo(i) {
        this.filtroLuogo = i;
        this.attestatiFiltrati = this.attestatiFiltra(this.filtroLuogo);
      },
      changeModalita(i) {
        this.filtromodalita = i;
        this.attestatiFiltrati = this.attestatiFiltra(this.filtromodalita);
      },
    },
  };
</script>
